<template>
  <v-card>
    <v-card-title>
      <div class="headline">
        Редактирование счетчика
        ({{ counterData.model_name || counterData.model.name }},
        {{ counterData.serial_num }})
      </div>
    </v-card-title>
    <v-card-text>
      <v-form ref="counterParamsForm">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="counter.serial_num"
                label="Серийный номер"
                :rules="inputRules"
                required
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="counter.coeff"
                label="Коэффициент трансформации тока"
                :rules="inputRules"
                required
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="counter.coeff_voltage"
                  label="Коэффициент трансформации напряжения"
                  :rules="inputRules"
                  required
              />
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        text
        @click="saveChanges"
      >Сохранить</v-btn>
      <v-btn
        color="primary"
        text
        @click="$emit('cancel')"
      >Отмена</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'CounterEdit',
  props: {
    counterData: {}
  },
  data () {
    return {
      inputRules: [
        v => !!v || 'Заполните это поле!'
      ],
      counter: {}
    }
  },
  mounted () {
    this.counter = Object.assign({}, this.counterData)
  },
  methods: {
    saveChanges () {
      if (this.$refs.counterParamsForm.validate()) {
        if (
          this.counter.coeff !== this.counterData.coeff ||
          this.counter.coeff_voltage !== this.counterData.coeff_voltage ||
          this.counter.serial_num !== this.counterData.serial_num
        ) {
          this.axios.patch(`/api/counters/${this.counter.counter_id}/`, this.counter)
            .then((response) => {
              this.$emit('edited', this.counter)
            })
            .catch((err) => {
              this.$emit('editError', err.response.data)
            })
        } else {
          this.$emit('cancel')
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/spa/counters/CounterEdit.vue